import React from "react";
import { Wordmark } from "@/components/Wordmark";

const cols = [
  {
    title: "Services",
    links: [
      "Funding Solutions",
      "Mergers & Acquisitions",
      "Valuations",
      "TEV Reports",
      "Advisory & Research",
    ],
  },
  {
    title: "Company",
    links: ["About", "Founder", "Industries", "Contact"],
  },
];

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/5 bg-[#08160F]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="text-2xl">
              <Wordmark />
            </div>
            <p className="mt-4 font-serif italic text-white/70 text-lg leading-snug max-w-sm">
              Transforming companies into corporations.
            </p>
            <p className="mt-6 text-sm text-white/55 leading-relaxed max-w-md">
              A hyper-personal investment banking and financial advisory practice headquartered
              in Visakhapatnam. Senior-led, mandate-driven, outcomes-obsessed.
            </p>
          </div>

          <div className="lg:col-span-4 grid grid-cols-2 gap-8">
            {cols.map((c) => (
              <div key={c.title}>
                <p className="text-overline text-brand-accent">{c.title}</p>
                <ul className="mt-4 space-y-3">
                  {c.links.map((l) => (
                    <li key={l}>
                      <span className="text-sm text-white/65 hover:text-white transition-colors">
                        {l}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:col-span-3">
            <p className="text-overline text-brand-accent">Registered office</p>
            <p className="mt-4 text-sm text-white/65 leading-relaxed">
              Bhanunidhi Business Solutions Pvt Ltd
              <br />
              #Away, 4th Floor, 10-50-58/1,
              <br />
              Above ZUDIO Store, Ramnagar,
              <br />
              Waltair Main Road,
              <br />
              Visakhapatnam, Andhra Pradesh
            </p>
            <div className="mt-5 space-y-1.5">
              <a
                href="tel:+919959133388"
                className="block text-sm text-white hover:text-brand-accent transition-colors"
              >
                +91 99591 33388
              </a>
              <a
                href="mailto:info@transformo.co.in"
                className="block text-sm text-white/70 hover:text-brand-accent transition-colors"
              >
                info@transformo.co.in
              </a>
            </div>
          </div>
        </div>

        <div className="section-divider mt-14" />

        <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Bhanunidhi Business Solutions Pvt Ltd. All rights
            reserved.
          </p>
          <p className="text-xs text-white/40">
            Confidential financial advisory · Visakhapatnam, India
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
